type OwnProps = {
  position: {
    rect: { top: number; left: number; right: number; bottom: number };
    scrollTop: number;
    scrollLeft: number;
  };
  arrowPosition: string;
  direction: string;
  contentWidth: number;
  offsetTooltip: { left?: number };
};

const TooltipPosition = ({
  position,
  arrowPosition,
  direction,
  contentWidth,
  offsetTooltip
}: OwnProps) => {
  const {
    rect: { top, left, right, bottom },
    scrollTop,
    scrollLeft
  } = position;
  const leftOffset = offsetTooltip.left || 0;
  const rightAlignment = right - contentWidth - leftOffset;
  const leftAlignment = left + leftOffset;
  const ARROW_OFFSET_MOBILE = 50;

  const adjustedTop = direction === 'down' ? top - 15 + scrollTop : bottom + 15 + scrollTop;
  const adjustedLeft =
    arrowPosition === 'right' ? rightAlignment + scrollLeft : leftAlignment + scrollLeft;

  const translation = direction === 'down' ? 'transform: translateY(-100%);' : '';

  return `
  ${translation}
  top: ${Math.max(0, adjustedTop)}px;
  left: ${Math.max(0, adjustedLeft + ARROW_OFFSET_MOBILE)}px;

  @media (min-width: 768px) {
    left: ${Math.max(0, adjustedLeft)}px;
  }
  `;
};

export default TooltipPosition;
